import { cva, cx, type VariantProps } from 'class-variance-authority';

export const selectCva = cva(
  [
    'flex w-full justify-between items-center group/select rounded-md px-4',
    'font-normal text-neutral-900',
    'cursor-pointer bg-white outline-none',
    'transition-shadow duration-150',
    'ring-1 ring-neutral-100',
    'data-focus:ring-neutral-800',
    'not-data-disabled:[.ng-invalid.ng-dirty>&]:ring-error-500',
    'not-data-disabled:[.ng-invalid.ng-touched>&]:ring-error-500',
    'data-disabled:text-neutral-200 data-disabled:ring-neutral-100 data-disabled:cursor-not-allowed',
  ],
  {
    variants: {
      size: {
        md: 'h-14',
        sm: 'h-10',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
);

export type SelectVariants = VariantProps<typeof selectCva>;
export type SelectSize = NonNullable<SelectVariants['size']>;

export const placeholderCva = cx(
  'flex-auto truncate',
  'text-start text-neutral-900 group-data-disabled/select:text-neutral-200 data-disabled:text-neutral-200',
);

export const dropdownCva = cva(
  [
    'fixed z-50 flex flex-col outline-none',
    'max-h-60 scrollbar overflow-y-auto gap-1 rounded-lg p-2',
    'border border-neutral-200 bg-white shadow-lg',
    'origin-(--ngp-select-transform-origin)',
    'w-(--ngp-select-width)',
    'ease-in-out',
  ],
  {
    variants: {
      withSearch: {
        false: '',
        true: 'pt-0',
      },
    },
    defaultVariants: {
      withSearch: false,
    },
  },
);

export const optionWrapperCva = cx('inline-flex items-center rounded-md');

export const optionCva = cx(
  'flex h-fit w-full items-center sticky top-0',
  'bg-white text-neutral-900 min-h-8 gap-2 rounded-md px-2.5',
  'cursor-pointer',
  'data-hover:bg-neutral-600/10',
  'data-disabled:cursor-not-allowed data-disabled:text-neutral-900/30',
);

export const emptyCva = cx(
  'flex h-21 w-full items-center justify-center',
  'min-h-8 rounded-md px-2.5',
  'text-center text-neutral-900',
  'cursor-default select-none bg-transparent',
);

export const fieldCva = cx('flex w-full flex-col data-disabled:cursor-not-allowed gap-1.5');
